import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../styles/cart.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getImageUrl } from "utils/helper";
import Loader from "components/loader/loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import { FILE_ENTITY_TYPE, EVENT_NAME, CUSTOMER_PRODUCT_POST_TYPE_MAP } from "utils/constants";
import { CustomerApi } from "api/customer.api";
import { AppApi } from "api/app.api";
import AddressList from "components/weddigservice/addressList";
import AddAddressPopup from "components/popup/addAddress";
import { CustomerProductApi } from "api/customer-product.api";
import CustomerProductAddThanksPopup from "components/popup/customerProductAddThanks";
import AnalyticsService from "services/analytics.service";

const AddCustomerProductItemPage = () => {
  const { postType } = useParams();

  const navigate = useNavigate(); // Initialize navigate for redirection

  const [customerProduct, setCustomerProduct] = useState({
    title: "",
    description: "",
    postType,
    imageUrl: null,
    listingPrice: 100,
    sellingPrice: 100,
  });
  const [customerAddressList, setCustomerAddressList] = useState([]);
  const [showAddAddressPopup, setShowAddAddressPopup] = useState(false);
  const [selectedCustomerAddressId, setSelectedCustomerAddressId] =
    useState(null);

  const [
    showCustomerProductAddThanksPopup,
    setShowCustomerProductAddThanksPopup,
  ] = useState(false);

  const getCustomerAddressList = async () => {
    const addressListResponse = await CustomerApi.getAddressList();
    setCustomerAddressList(addressListResponse);

    if (addressListResponse.length >= 1) {
      setSelectedCustomerAddressId(addressListResponse[0].id);
    }
  };

  useEffect(() => {
    getCustomerAddressList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(customerProduct);
    if (!customerProduct.title) {
      toast.error("Please enter title");
      return;
    }
    if (!customerProduct.description) {
      toast.error("Please enter description");
      return;
    }
    if (!customerProduct.imageUrl) {
      toast.error("Please upload image");
      return;
    }
    if (!customerProduct.sellingPrice) {
      toast.error(`Please enter ${CUSTOMER_PRODUCT_POST_TYPE_MAP.ADD_PRODUCT_FILED_NAME.SELLING_PRICE[postType]}`);
      return;
    }

    if (!selectedCustomerAddressId) {
      toast.error(`Please select ${CUSTOMER_PRODUCT_POST_TYPE_MAP.ADD_PRODUCT_FILED_NAME.ADDRESS[postType]}`);
      return;
    }

    try {
      const response = await CustomerProductApi.createCustomerProduct({
        ...customerProduct,
        customerAddressId: selectedCustomerAddressId,
      });
      AnalyticsService.trackEvent(EVENT_NAME.CUSTOMER_PRODUCT_ADDED, {
        customerProductId: response.id,
        title: customerProduct.title,
        postType: postType,
        description: customerProduct.description,
        sellingPrice: customerProduct.sellingPrice,
        listingPrice: customerProduct.listingPrice,
        customerAddressId: selectedCustomerAddressId,
      });

      setCustomerProduct({});
      setShowCustomerProductAddThanksPopup(true);
    } catch (error) {
      console.error("Error creating customer product:", error);
      toast.error("Error creating customer product");
    }
  };

  if (showCustomerProductAddThanksPopup) {
    return (
      <CustomerProductAddThanksPopup
        onClose={() => {
          setShowCustomerProductAddThanksPopup(false);
          navigate(`/customer-products/${postType}`);
        }}
        postType={postType}
      />
    );
  }

  return (
    <>
      {!customerProduct ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <div>
            <h4 className="category-title" style={{marginBottom: "0px"}}>{CUSTOMER_PRODUCT_POST_TYPE_MAP.ADD_PRODUCT_PAGE_TITLE[postType]}</h4>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              margin: "20px",
            }}
            onSubmit={handleSubmit}
          >
            <label>Title</label>
            <input
              className="input-field-for-address"
              type="text"
              placeholder="Title"
              value={customerProduct.title}
              onChange={(e) =>
                setCustomerProduct({
                  ...customerProduct,
                  title: e.target.value,
                })
              }
            />
            <label>Description</label>
            <textarea
              className="input-field-for-address"
              placeholder="Description"
              value={customerProduct.description}
              onChange={(e) =>
                setCustomerProduct({
                  ...customerProduct,
                  description: e.target.value,
                })
              }
            />
            <label>Image</label>
            <input
              type="file"
              accept="image/*"
              placeholder="Image"
              className="input-field-for-address"
              onChange={async (e) => {
                try {
                  const file = e.target.files[0];
                  if (file) {
                    const { filePath } = await AppApi.uploadFile(
                      FILE_ENTITY_TYPE.CUSTOMER_PRODUCT_FILE,
                      file
                    );
                    setCustomerProduct({
                      ...customerProduct,
                      imageUrl: filePath,
                    });
                  }
                } catch (error) {
                  console.error("Error uploading image:", error);
                }
              }}
            />
            {customerProduct.imageUrl && (
              <div className="image-preview">
                <img
                  src={getImageUrl(customerProduct.imageUrl)}
                  alt="Merchant preview"
                  style={{ maxWidth: "100px", maxHeight: "100px" }}
                />
              </div>
            )}
            <label>{CUSTOMER_PRODUCT_POST_TYPE_MAP.ADD_PRODUCT_FILED_NAME.SELLING_PRICE[postType]}</label>
            <input
              className="input-field-for-address"
              type="number"
              placeholder="Selling Price"
              value={customerProduct.sellingPrice}
              onChange={(e) =>
                setCustomerProduct({
                  ...customerProduct,
                  sellingPrice: e.target.value,
                  listingPrice: e.target.value,
                })
              }
            />
            <AddressList
              title={CUSTOMER_PRODUCT_POST_TYPE_MAP.ADD_PRODUCT_FILED_NAME.ADDRESS[postType]}
              customerAddressList={customerAddressList}
              selectedCustomerAddressId={selectedCustomerAddressId}
              handleSelectAddress={(address) => {
                setSelectedCustomerAddressId(address.id);
              }}
              showDeleteButton={false}
              handleAddAddress={() => {
                setShowAddAddressPopup(true);
              }}
            />
            <button className="save-address-btn" type="submit">
              Add {CUSTOMER_PRODUCT_POST_TYPE_MAP.BUTTON_TEXT[postType]}
            </button>
          </form>

          {showAddAddressPopup && (
            <AddAddressPopup
              onClose={() => setShowAddAddressPopup(false)}
              onAddAddressComplete={() => {
                getCustomerAddressList();
              }}
            />
          )}

          <ToastContainer
            id="cart-toast-container"
            style={{ width: "300px" }}
            position="top-center"
            autoClose={3000}
          />
        </div>
      )}
    </>
  );
};

export default AddCustomerProductItemPage;
